<template>   
  <div
    v-if="price == 0"
    id="template_launch_title"
    class="text-xl text-center font-medium text-grayCust-1550 flex justify-center items-center break-all"
  >
    <div class="">
      {{ title }}
    </div> 
    <div
      v-if="monetize"
      class="py-1 ml-2 px-3 bg-secondary-150 text-xs text-secondary-700 font-medium rounded-2xl"
    >
      Free
    </div>
  </div>
  <div
    v-else
    class="flex items-start gap-2 justify-between"
  >
    <div class="text-xl font-medium text-grayCust-1550">
      {{ title }}
    </div>
    <div class="font-bold text-grayCust-1550 text-2xl mt-0.5">
      ${{ price }}<span class="text-base font-medium text-grayCust-500">{{ interval }}</span>
    </div>
  </div>
</template>

<script>
export default {
   name: "Header",
   props:{
      title: {
         type: String,
         require: true,
      },
      price: {
         type: Number,
         default: 0,
      },
      monetize: {
         type: Boolean,
         default: false,
      },
      interval: {
         default: '',
         type: String,
      }
   },
}
</script>
<style scoped>
.header-width{
   max-width: 288px;
}
</style>
